/* @flow */

import React from 'react';
import ReactDOM from 'react-dom';

import IsomorphicRouter from 'isomorphic-relay-router';

import getEnvironment from './getEnvironment';
import Provider from './WrappedIntlProvider';
import EnvironmentManager from './EnvironmentManager';

import { match, applyRouterMiddleware, Router } from 'react-router';

import routes from './routes';

const myRender = applyRouterMiddleware(IsomorphicRouter.useIsoRelay);

/*
 * The purpose of all this, is to make it possible to reset the Relay cache.  We
 * do this by creating a brand new Relay environment and re-rendering the whole
 * page.
 *
 * A reset function is made available to all components via context, it accepts
 * a callback which is called when the re-render is complete.
 *
 * The main use case is to make login/logout work.
 */
export default function renderEnvironment(
  renderTarget,
  store,
  environment,
  history,
) {
  function reset(callback) {
    const environment = getEnvironment();
    render(environment, () => (callback ? callback(environment) : null));
  }

  function render(currentEnvironment, callback = null) {
    match({ routes, history }, (error, redirectLocation, renderProps) => {
      IsomorphicRouter.prepareInitialRender(
        currentEnvironment,
        renderProps,
      ).then(props => {
        ReactDOM.render(
          <EnvironmentManager key={currentEnvironment.id} reset={reset}>
            <Provider store={store}>
              <Router
                {...props}
                render={myRender}
                history={history}
                routes={routes}
                environment={currentEnvironment}
              />
            </Provider>
          </EnvironmentManager>,
          renderTarget,
          callback,
        );
      });
    });
  }

  render(environment);
}



// WEBPACK FOOTER //
// ../src/client/renderEnvironment.js